import actions from "@/store/modules/gross-product/actions";
import mutations from "@/store/modules/gross-product/mutations";
import state from "@/store/modules/gross-product/state";

export default {
    actions,
    mutations,
    state
}
